import forEach from "ramda/src/forEach";
import { isString } from "cci-utility";

/**
 * Checks if the currently logged in user has access to perform the specified action(s) on the specified object(s).
 *
 * The checkPermission object has the following options:
 *
 * objects Name of the object(s) for which we are checking if the action can be performed. For example "Business".
 * If you need to check if an action can be performed on one object or another, you can use the "|" character to query it.
 * So for example, you can do "Business|Office" and this will check whether the action can be performed on Business OR Office.
 *
 * actions Action(s) that we are checking whether it can be performed on the object, this is any CRUD operation. For example "create", "read", "update" or "delete".
 *
 * Both of these options can be specified as either a string or an array.
 *
 * @return True if the user has permissions to access the object(s), false otherwise.
 */
const hasPermissions = (
  permissions,
  { objects: objectsIn, actions: actionsIn }
) => {
  let granted = false,
    objects = objectsIn,
    actions = actionsIn;

  if (isString(objects)) {
    // Ensure objects are always an array
    objects = objects.split("|");
  }

  if (isString(actions)) {
    // Ensure actions are always an array
    actions = actions.split(",");
  }

  forEach(permission => {
    if (granted === true) {
      // Make sure to break if permission was granted (optimization)
      return;
    }

    forEach(checkObject => {
      if (granted === true) {
        // Permission was already granted, so we don't do anything else
        return;
      }

      const permissionObject = new RegExp("\\b" + permission.object.replace("*", ".*") + "\\b");

      if (permissionObject.test(checkObject)) {
        // Has permission to the object.
        forEach(action => {
          if (granted === true) {
            // Permission was already granted, so we don't do anything else
            return;
          }

          forEach(checkAction => {
            // Make or may not have permission to the object.

            if (granted === true) {
              // Permission was already granted, so we don't do anything else
              return;
            }

            const permissionAction = new RegExp("\\b" + action.replace("*", ".*") + "\\b");

            // This performs the regex check against the action specified.
            granted = permissionAction.test(checkAction);
          }, actions);
        }, permission.actions);
      }
    }, objects);
  }, permissions);

  return granted;
};

export default hasPermissions;
